<template>
    <div class="d-flex flex-wrap flex-column">
        <div class="d-flex justify-content-between" style="width:100%">

            <div class="d-flex justify-content-between align-items-center">

                <small v-if="item.read_at"><i class="fas fa-check"></i> Tarefa visualizada
                    {{ moment(item.read_at).format("LLLL") }}
                </small>
                <b-button variant="link" @click.prevent="verTarefa()"><small>Ver tarefa</small></b-button>
            </div>
        </div>

    </div>
</template>
<script>
import Comentario from "../../tarefas/forms/Comentario.vue";
import { mapActions } from "vuex";
export default {
    components: { Comentario },
    props: {
        item: Object
    },
    data() {
        return {
            show_form: false,
            comentario: null,
        };
    },
    methods: {
        ...mapActions("notification", ["markAsRead"]),
        verTarefa() {
            this.read();
            this.$root.$emit('verTarefa', this.item);
        },
        read() {
            this.markAsRead(this.item);
            this.$emit("hideDropdown");
        },
    }
}
</script>

